import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";

class FinanceService {
  DoGetUnreceivedCheque(type: number) {
    const _input = {
      merchantId: MerchantId(),
      followingList: type,
    };

    return service.peakExportAPI.post("/api/DashBoard/GetUnreceivedCheque", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetMerchantMonitoringFinance() {
    const _input = {
      merchantId: MerchantId(),
      date: new Date(),
      language: i18n.locale,
    };
    return service.peakExportAPI
      .post("/api/DashBoard/GetMerchantMonitoringFinance", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoSetMerchantMonitoringFinance(followingList: any) {
    const _input = {
      merchantId: MerchantId(),
      followingList: followingList,
    };

    return service.peakExportAPI
      .post("/api/DashBoard/SetMerchantMonitoringFinance", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoGetMerchantMonitoringFinanceByFinanceIdList(followingList: any) {
    const _input = {
      merchantId: MerchantId(),
      date: new Date(),
      language: i18n.locale,
      followingList: followingList,
    };

    return service.peakExportAPI
      .post("/api/DashBoard/GetMerchantMonitoringFinanceByFinanceIdList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetAllBankAccount(isUseMainDatabase = false) {
    const _input = {
      merchantId: MerchantId(),
      language: i18n.locale,
      isUseMainDatabase: isUseMainDatabase,
    };

    return service.peakRealTimeAPI.post("/api/Finance/GetAllBankAccount", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}

export default new FinanceService();
